// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"716":"ea3b0664","970":"9fc42783"}[chunkId] + ".chunk.css";
};